
























































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {},
})
export default class Landing extends Vue {
    category: number = 0;
    games1: any = [];
    games2: any = []
    //parameters
    limit: number = 6;
    offset: number = 0;
    sort: string = 'c';
    dir: string = 'asc'

    //state
    isAddData: boolean = false;
    hasData: boolean = true;

    mounted() {
        this.officalFetch()
    }

    login() {
        this.$router.push(`/${this.i18n.locale}/login`)
    }

    gameUpload() {
        this.$modal.show('gameUpload')
    }

    officalFetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            // category: this.category,
            sort: this.sort,
            dir: this.dir
        };

        this.$api.gameList(obj)
            .then((res: any) => {
                this.games1 = res.result.games.slice(0,2)
                this.games2 = res.result.games.slice(2,6);

            })
    }
    playGame(pathname:string){
        window.open(
            `play/${pathname}`, "_blank")
    }

    openCommunity(){
        window.open('https://zempie.com/community/18a26bd9-353f-41a9-b9d7-e846a9b41a2b/timeline')
    }

}
